import React, { FC } from 'react';
import styled from 'styled-components';
import { H2 } from '../base/typography';
import NewsletterForm from '../newsletterForm';

const Subheading = styled.div`
	margin: 2rem 0;
`;

interface Props {
	title: string;
	paragraph?: string;
}

const Newsletter: FC<Props> = ({ title, paragraph }) => {
	return (
		<div>
			<H2>{title}</H2>
			<Subheading>{paragraph}</Subheading>
			<NewsletterForm />
		</div>
	);
};

export default Newsletter;
